import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import React from 'react'
import { EntradaSaidaManutencaoProps } from './types'

const EntradaDiaSeguinte: React.FC<EntradaSaidaManutencaoProps> = ({
    categoria,
    saidaDiaAnterior,
    entradaDiaSeguinte,
    isLoading,
    toggle,
}) => {
    if (categoria === 5) return null

    return (
        <FormControlLabel
            control={<Checkbox />}
            label="Entrada no dia seguinte"
            disabled={saidaDiaAnterior === 'S' || isLoading}
            checked={entradaDiaSeguinte === 'S'}
            onChange={() => toggle('entrada-dia-seguinte')}
        />
    )
}

export default EntradaDiaSeguinte
